<template>
  <div class="rating-chart">
    <div>
      <div class="rating-chart__title">5 {{ textStars }}</div>
      <div class="rating-chart__bar">
        <div style="width: 83%"></div>
      </div>
      <div class="rating-chart__count">
        (16,928)
      </div>
    </div>

    <div>
      <div class="rating-chart__title">4 {{ textStars }}</div>
      <div class="rating-chart__bar">
        <div style="width: 14%"></div>
      </div>
      <div class="rating-chart__count">
        (1,570)
      </div>
    </div>

    <div>
      <div class="rating-chart__title">3 {{ textStars }}</div>
      <div class="rating-chart__bar">
        <div style="width: 0%"></div>
      </div>
      <div class="rating-chart__count">
        (0)
      </div>
    </div>

    <div>
      <div class="rating-chart__title">2 {{ textStars }}</div>
      <div class="rating-chart__bar">
        <div style="width: 0%"></div>
      </div>
      <div class="rating-chart__count">
        (0)
      </div>
    </div>

    <div>
      <div class="rating-chart__title">1 {{ textStar }}</div>
      <div class="rating-chart__bar">
        <div style="width: 0%"></div>
      </div>
      <div class="rating-chart__count">
        (0)
      </div>
    </div>
  </div>
</template>

<script>
// For now all data is static

import { t } from "../../utils/i18n";

export default {
  name: "RatingChart",
  computed: {
    textStar: () => t("review.star"),
    textStars: () => t("review.stars")
  }
};
</script>

<style lang="scss">
.rating-chart {
  > div {
    display: flex;
    margin-bottom: 5px;
  }

  &__title {
    font-weight: bold;
    width: 27%;
    white-space: nowrap;
    font-size: 13px;
  }

  &__bar {
    background-color: #dfdfdf;
    width: 53%;
    height: 12px;
    vertical-align: middle;
    margin: 4px 10px;

    > div {
      height: 100%;
      background-color: #3574d7;
    }
  }

  &__count {
    color: #ccc;
    width: 20%;
    font-size: 12px;
  }
}
</style>
